/* eslint-disable import/prefer-default-export */
export const sizes = {
    TINY: 'TINY',
    SMALL: 'SMALL',
    MEDIUM: 'MEDIUM',
    LARGE: 'LARGE',
    FULL_WIDTH: 'FULL_WIDTH',
};
